import { Badge, Skeleton } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { soVN } from '../../../../lib/dinh-dang';
import { MUC_QUYEN } from '../../constants-bot';
import { useQuyenHieuLuc } from '../../hooks/useQuyen';
import type { GraphqlSource } from '../../types';
import { DaiLoi } from '../chung/VungDuLieu';

/** "Tôi đọc được gì" — ai cũng tra được phần của chính mình, kể cả người không sửa được ma trận. */
export function QuyenCuaToi({ nguon }: { nguon?: GraphqlSource[] }) {
  const { t, locale } = useT();
  const q = useQuyenHieuLuc();
  const tenNguon = (id: string) => nguon?.find((s) => s.id === id)?.name ?? id;

  return (
    <section className="space-y-2 p-5" aria-label={t('troLyAiBotQuyenDuLieu.quyenCuaToi')}>
      <p className="text-xs font-medium text-content-primary">
        {q.data?.role
          ? t('troLyAiBotQuyenDuLieu.quyenCuaToiVai', { vai: q.data.role })
          : t('troLyAiBotQuyenDuLieu.quyenCuaToi')}
      </p>
      {q.error ? (
        <DaiLoi loi={q.error} onThuLai={() => void q.refetch()} />
      ) : !q.data ? (
        <Skeleton className="h-10 rounded" />
      ) : q.data.sources.length ? (
        <ul className="space-y-1.5">
          {q.data.sources.map((s) => (
            <li key={s.sourceId} className="flex flex-wrap items-center gap-2 text-xs">
              <span className="text-content-secondary">{tenNguon(s.sourceId)}</span>
              <Badge variant={MUC_QUYEN[s.level].variant}>
                {t(MUC_QUYEN[s.level].nhan, { n: soVN(s.tables.length, locale) })}
              </Badge>
              {s.tables.map((x) => (
                <span key={x.table} className="font-mono text-content-secondary">
                  {x.table}
                  {x.deniedColumns.length ? (
                    <span className="text-warning-700">
                      {t('troLyAiBotQuyenDuLieu.giauDs', { ds: x.deniedColumns.join(', ') })}
                    </span>
                  ) : null}
                </span>
              ))}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-xs text-content-muted">{t('troLyAiBotQuyenDuLieu.chuaCoNguonMoChoVai')}</p>
      )}
    </section>
  );
}
